import React from 'react';
import queryString from 'query-string';

const MEMBERSHIP_PARAM_KEY = 'auto-ship';

export default class MembershipQueryParamCheck extends React.Component {
  state = {
    hasRemovedParam: false,
  };

  componentDidMount() {
    const params = queryString.parse(location.search);
    const membershipParam = params[MEMBERSHIP_PARAM_KEY];

    this.setState({ params });

    if (!this.props.hasMembership && membershipParam === 'true') {
      this.props.turnOnMembership();
      this.removeParam();
    } else if (membershipParam) {
      this.removeParam();
    }
  }

  componentWillReceiveProps(nextProps) {
    const shouldRemoveParam =
      !this.state.hasRemovedParam && nextProps.hasSavedCart === true;
    if (shouldRemoveParam) {
      this.removeParam();
    }
  }

  render() {
    return null;
  }

  removeParam() {
    const paramsNew = { ...this.state.params };
    delete paramsNew[MEMBERSHIP_PARAM_KEY];
    let paramsNewString = queryString.stringify(paramsNew);
    paramsNewString = paramsNewString.length > 0 ? `?${paramsNewString}` : '';
    const urlNew = location.pathname + paramsNewString;
    history.replaceState('', '', urlNew);
    this.setState({ hasRemovedParam: true });
  }
}



// WEBPACK FOOTER //
// ./app/javascript/apps/cart/components/MembershipQueryParamCheck.js